import { makeVar } from '@apollo/client'

import { EntityDetails } from './getEntity.types'

export const rvEntityDetails = makeVar({} as EntityDetails)
